import React, { useEffect } from "react";

import { useDispatch } from "react-redux";
import OgImage from "../../assets/landingPages/homePage/Hero.png";
import { ReactComponent as HeroEllipseGroup } from "../../assets/payment/Group 1171275041.svg";

import { gettingPaymentsPalnsList } from "../../redux/slices/paymentStripes/paymentStripesSlice";
import { Outlet } from "react-router-dom";
import useLocales from "../../hooks/useLocales";
import { Helmet } from "react-helmet";

const PricingPage = () => {
  const dispatch = useDispatch();
  const { currentLang } = useLocales();

  useEffect(() => {
    gettingPaymentsPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const gettingPaymentsPlans = () => {
    dispatch(gettingPaymentsPalnsList());
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Pricing | Bil.Bio</title>
        <meta property="og:title" content="Pricing | Bil.Bio" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:image" content={window.location.origin + OgImage} />
        <meta property="og:description" content="Create Bio Link page" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={currentLang?.value} />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Bil.Bio" />
        <meta
          name="twitter:description"
          content="Bil.Bio | All links in link"
        />
        <meta name="twitter:site" content="@BilBioHQ" />
        <meta name="twitter:image" content={window.location.origin + OgImage} />
      </Helmet>
      <section className="-mt-[93px]  bg-[#fbf7f7] dark:bg-dark-primary pt-[93px]">
        <HeroEllipseGroup className="absolute top-0 left-0 h-[22rem] md:h-[26rem]" />
        <div className="flex justify-center">
          <div className="2xl:max-w-screen-xl xl:max-w-screen-lg w-full">
            <Outlet />
          </div>
        </div>
      </section>
    </>
  );
};

export default PricingPage;
